<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col>
          <b-row>
            <b-col sm="12">
              <b-card header-class="redmfu">
                <div slot="header">
                  <strong v-if="thai_student==1">ตอนที่ 2 สำหรับผู้มีงานทำ (สถานที่ทำงานปัจจุบัน)</strong>
                  <strong v-else>Part 2 For Employed graduates</strong>
                  <div style="float:right;">
                    <b-badge pill variant="warning" class="font-sm text-dark p-2 pr-3 pl-3">Session Timeout :
                      {{ this.$store.state.timeExp }}
                    </b-badge>
                  </div>
                </div>
                <div>
                </div>
                <b-row>
                  <b-col sm="12">
                    <strong><br><u>
                      <div align="left" v-if="thai_student==1">สถานที่ทำงานปัจจุบัน (โปรดระบุให้ชัดเจน
                        เพราะมีความสำคัญต่อการพัฒนาบัณฑิตของมหาวิทยาลัย)
                      </div>
                      <div align="left" v-else> Current Work Address (Please provide clear information, the information
                        is important for graduate development.)
                      </div>
                    </u><br></strong>
                  </b-col>
                </b-row>
                <b-row><br></b-row>
                <!--                <div>{{item1s}}</div>-->
                <div v-for="item1 in item1s" v-bind:key="item1.QUESTION_PK" v-if=" item1.QUESTION_PK<24">
                  <!--               {{item1.QUESTION_PK}}-->

                  <!-- start -->
                  <b-form-group
                    class="text-danger"
                    v-if="(items2[item1.QUESTION_PK-11].VALUES ==2)"
                    :label="'*  ' +item1.NUMBER  + ') '+item1.QUESTION_NAME"
                    label-for="basicInlineRadios"
                    :label-cols="12"
                  ></b-form-group>
                  <b-form-group
                    v-else
                    :label="item1.NUMBER  + ') '+item1.QUESTION_NAME"
                    label-for="basicInlineRadios"
                    :label-cols="12"
                  ></b-form-group>
                  <b-form-group
                    label-cols-sm="1"
                    label
                    label-align-sm="right"
                    label-for="nested-street"
                  >

                    <div v-if="item1.QUESTION_PK=='11' ">
                      <v-select
                        label="COUNTRYNAME"
                        :options="countryItems"
                        v-model="select_country1"
                        @input="selectCountryOnchange">
                      </v-select>
                    </div>
                    <div v-if="item1.QUESTION_PK=='12' ">
                      <b-form-input
                        v-if="item1.CONTROL_Q==1 && item1.QUESTION_PK=='12' "
                        id="current_no"
                        type="text"
                        autocomplete="current_no"
                        v-model="current_no"
                        :state="validation_no"
                      ></b-form-input>
                      <b-form-invalid-feedback :state="validation_no">
                        กรอกบ้านเลขที่เท่านั้น (หมู่บ้าน อาคาร/ตึก กรอกด้านล่าง)
                      </b-form-invalid-feedback>
                      <b-form-valid-feedback :state="validation_no">
                        Correct.
                      </b-form-valid-feedback>
                    </div>
                    <div v-if="item1.CONTROL_Q==1 && item1.QUESTION_PK=='13' ">
                      <b-form-input
                        v-if="item1.CONTROL_Q==1 && item1.QUESTION_PK=='13' "
                        id="current_moo"
                        type="text"
                        autocomplete="current_moo"
                        v-model="current_moo"
                        :state="validation_moo"
                        placeholder=""
                      ></b-form-input>
                      <b-form-invalid-feedback :state="validation_moo">
                        Your moo must be 1-50 characters long.
                      </b-form-invalid-feedback>
                      <b-form-valid-feedback :state="validation_moo">
                        Correct.
                      </b-form-valid-feedback>
                    </div>
                    <div v-if="item1.CONTROL_Q==1 && item1.QUESTION_PK=='14' ">
                      <b-form-input
                        v-if="item1.CONTROL_Q==1 && item1.QUESTION_PK=='14' "
                        id="current_building"
                        type="text"
                        autocomplete="current_building"
                        v-model="current_building"
                        :state="validation_build"
                        placeholder=""
                      ></b-form-input>
                      <b-form-invalid-feedback :state="validation_build">
                        Your building must be 1-50 characters long.
                      </b-form-invalid-feedback>
                      <b-form-valid-feedback :state="validation_build">
                        Correct.
                      </b-form-valid-feedback>

                    </div>
                    <div v-if="item1.CONTROL_Q==1 && item1.QUESTION_PK=='15' ">

                      <b-form-input
                        v-if="item1.CONTROL_Q==1 && item1.QUESTION_PK=='15' "
                        id="current_lane"
                        type="text"
                        autocomplete="current_lane"
                        v-model="current_lane"
                        :state="validation_soi"
                        placeholder=""
                      ></b-form-input>
                      <b-form-invalid-feedback :state="validation_soi">
                        Your soi must be 1-50 characters long.
                      </b-form-invalid-feedback>
                      <b-form-valid-feedback :state="validation_soi">
                        Correct.
                      </b-form-valid-feedback>
                    </div>
                    <div v-if="item1.CONTROL_Q==1 && item1.QUESTION_PK=='16' ">
                      <b-form-input
                        v-if="item1.CONTROL_Q==1 && item1.QUESTION_PK=='16' "
                        id="current_road"
                        type="text"
                        autocomplete="current_road"
                        v-model="current_road"
                        :state="validation_road"
                        placeholder=""
                      ></b-form-input>
                      <b-form-invalid-feedback :state="validation_road">
                        Your road must be 1-50 characters long.
                      </b-form-invalid-feedback>
                      <b-form-valid-feedback :state="validation_road">
                        Correct.
                      </b-form-valid-feedback>
                    </div>
                    <div v-if=" item1.QUESTION_PK=='17'">
                      <b-form-select
                        v-if="select_country =='TH'"
                        value-field="PROVINCE_ID"
                        text-field="PROVINCENAME"
                        size="md"
                        :stacked="true"
                        :options="provinceItems"
                        v-model="select_province"
                        v-on:change="selectProvinceOnchange"
                      ></b-form-select>
                      <b-form-input
                        v-else
                        id="current_province"
                        type="text"
                        autocomplete="current_province"
                        v-model="current_province"
                        :state="validation_province"
                        placeholder=""
                      ></b-form-input>
                      <div v-if="select_country !='TH'">
                        <b-form-invalid-feedback :state="validation_province">
                          Your province must be 1-50 characters long.
                        </b-form-invalid-feedback>
                        <b-form-valid-feedback :state="validation_province">
                          Correct.
                        </b-form-valid-feedback>
                      </div>
                    </div>
                    <div v-if=" item1.QUESTION_PK=='18'">
                      <b-form-select
                        v-if=" select_country =='TH' "
                        value-field="DISTRICTID"
                        text-field="DISTRICTNAME"
                        class="mb-3"
                        :stacked="true"
                        :options="districtItems"
                        v-model="select_district"
                        v-on:change="selectDistrictOnchange"
                      ></b-form-select>
                      <b-form-input
                        v-else
                        id="current_district"
                        type="text"
                        autocomplete="current_district"
                        v-model="current_district"
                        :state="validation_district"
                        placeholder=""
                      ></b-form-input>
                      <div v-if="select_country !='TH'">
                        <b-form-invalid-feedback :state="validation_district">
                          Your district must be 1-50 characters long.
                        </b-form-invalid-feedback>
                        <b-form-valid-feedback :state="validation_district">
                          Correct.
                        </b-form-valid-feedback>
                      </div>
                    </div>
                    <div v-if=" item1.QUESTION_PK=='19'">
                      <b-form-select
                        v-if="select_country =='TH' "
                        value-field="SUB_DISTRICTID"
                        text-field="SUB_DISTRICTNAME"
                        size="md"
                        :stacked="true"
                        :options="subdistrictItems"
                        v-model="select_subdistrict"
                        v-on:change="selectSubDistrictOnchange"
                      ></b-form-select>
                      <b-form-input
                        v-else
                        id="current_subdistrict"
                        type="text"
                        autocomplete="current_subdistrict"
                        v-model="current_subdistrict"
                        :state="validation_subdistrict"
                        placeholder=""
                      ></b-form-input>
                      <div v-if="select_country !='TH'">
                        <b-form-invalid-feedback :state="validation_subdistrict">
                          Your subdistrict must be 1-50 characters long.
                        </b-form-invalid-feedback>
                        <b-form-valid-feedback :state="validation_subdistrict">
                          Correct.
                        </b-form-valid-feedback>
                      </div>
                    </div>
                    <b-form-input
                      v-if="item1.CONTROL_Q==1 && item1.QUESTION_PK=='20'  "
                      id="current_zipcode"
                      type="text"
                      autocomplete="current_zipcode"
                      v-model="current_zipcode"
                      :state="validation_zipcode"
                    ></b-form-input>

                    <div v-if="select_country=='TH'">
                      <b-form-input
                        v-if="item1.CONTROL_Q==1 && item1.QUESTION_PK=='21' "
                        id="current_tel"
                        type="text"
                        autocomplete="current_tel"
                        v-model="current_tel"
                        maxlength=10
                        :state="validation_tel"
                      >{{ current_tel }}
                      </b-form-input>
                      <b-form-invalid-feedback :state="validation_tel" v-if="item1.QUESTION_PK=='21'">
                        Your mobilephone must be 9-10 characters long.
                      </b-form-invalid-feedback>
                      <b-form-valid-feedback :state="validation_tel" v-if="item1.QUESTION_PK=='21' ">
                        Correct.
                      </b-form-valid-feedback>
                      <b-form-group v-if="item1.QUESTION_PK=='21' && thai_student==1"
                                    label="ตัวอย่าง 0936601665 (9-10 ตัว ไม่เว้นวรรค ไม่มีสัญลักษณ์)"
                                    :label-cols="6"></b-form-group>
                      <b-form-group v-if="item1.QUESTION_PK=='21'&& thai_student==0" label="Example 0936601665"
                                    :label-cols="6"></b-form-group>
                    </div>
                    <div v-else>
                      <b-form-input
                        v-if="item1.CONTROL_Q==1 && item1.QUESTION_PK=='21' "
                        id="current_tel"
                        type="text"
                        autocomplete="current_tel"
                        v-model="current_tel"
                        maxlength=30
                        :state="validation_teleng"
                      >
                        <!--                      @change="changetel"-->
                      </b-form-input>
                      <b-form-invalid-feedback :state="validation_teleng" v-if="item1.QUESTION_PK=='21'">
                        Your mobilephone must be 9-30 characters long.
                      </b-form-invalid-feedback>
                      <b-form-valid-feedback :state="validation_teleng" v-if="item1.QUESTION_PK=='21' ">
                        Correct.
                      </b-form-valid-feedback>
                      <b-form-group v-if="item1.QUESTION_PK=='21' && thai_student==1"
                                    label="ตัวอย่าง 0936601665 (ไม่เว้นวรรค ไม่มีสัญลักษณ์)"
                                    :label-cols="6"></b-form-group>
                      <b-form-group v-if="item1.QUESTION_PK=='21'&& thai_student==0" label="Example 0936601665"
                                    :label-cols="6"></b-form-group>
                    </div>

                    <div v-if="select_country=='TH'">
                      <b-form-input
                        v-if="item1.CONTROL_Q==1 && item1.QUESTION_PK=='22'"
                        id="current_fax"
                        type="text"
                        autocomplete="current_fax"
                        v-model="current_fax"
                        maxlength=10
                        :state="validation_fax"
                      ></b-form-input>
                      <b-form-group v-if=" item1.QUESTION_PK=='22'"
                                    label="Example 0936601665 or - "
                                    :label-cols="12"></b-form-group>
                      <b-form-invalid-feedback :state="validation_fax" v-if="item1.QUESTION_PK=='22'">
                        Your fax must be 9-10 characters long.
                      </b-form-invalid-feedback>
                      <b-form-valid-feedback :state="validation_fax" v-if="item1.QUESTION_PK=='22' ">
                        Correct.
                      </b-form-valid-feedback>
                    </div>
                    <div v-else>
                      <b-form-input
                        v-if="item1.CONTROL_Q==1 && item1.QUESTION_PK=='22'"
                        id="current_fax"
                        type="text"
                        autocomplete="current_fax"
                        v-model="current_fax"
                        maxlength=30
                        :state="validation_fax"
                      ></b-form-input>
                      <b-form-group v-if=" item1.QUESTION_PK=='22'"
                                    label="Example 0936601665 or - "
                                    :label-cols="12"></b-form-group>
                      <b-form-invalid-feedback :state="validation_fax" v-if="item1.QUESTION_PK=='22'">
                        Your fax must be 9-30 characters long.
                      </b-form-invalid-feedback>
                      <b-form-valid-feedback :state="validation_fax" v-if="item1.QUESTION_PK=='22' ">
                        Correct.
                      </b-form-valid-feedback>

                    </div>
                    <b-form-input
                      v-if="item1.CONTROL_Q==1 && item1.QUESTION_PK=='23'"
                      id="current_email"
                      type="email"
                      autocomplete="current_email"
                      v-model="current_email"
                      :state="validation_email"
                    ></b-form-input>
                    <b-form-group v-if=" item1.QUESTION_PK=='23'"
                                  label="Email"
                                  :label-cols="12"></b-form-group>
                    <b-form-invalid-feedback :state="validation_email" v-if="item1.QUESTION_PK=='23' ">
                      Please enter a valid email address.
                    </b-form-invalid-feedback>
                    <b-form-valid-feedback :state="validation_email" v-if="item1.QUESTION_PK=='23' ">
                      Correct.
                    </b-form-valid-feedback>


                  </b-form-group>
                  <!--end-->
                </div>


                <div slot="footer" class="text-center">
                  <b-button type="submit" size="md" class="mr-2" variant="success" @click="onBack">
                    <i class="fa fa-arrow-circle-o-left"></i> Back
                  </b-button>
                  <b-button type="submit" size="md" class="mr-2" variant="primary" @click="onSubmit">
                    <i class="fa fa-dot-circle-o"></i> Submit
                  </b-button>

                  <b-button type="reset" size="md" class="mr-2" variant="danger" @click="onReset">
                    <i class="fa fa-ban"></i> Reset
                  </b-button>
                </div>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="6"></b-col>
      </b-row>
    </div>

    <b-modal v-if="thai_student==1"
             title="คุณกรอกข้อมูลไม่ครบถ้วน"
             class="modal-danger"
             v-model="dangerModal"
             @ok="dangerModal = false"
             ok-variant="danger"
    >{{ current_erorrtxt }}
    </b-modal>
    <b-modal v-if="thai_student==0"
             title="You didn’t fill your information completely"
             class="modal-danger"
             v-model="dangerModal"
             @ok="dangerModal = false"
             ok-variant="danger"
    >{{ current_erorrtxt }}
    </b-modal>
  </div>
</template>

<script>
import YimoVueEditor from "../../../node_modules/yimo-vue-editor/src/Editor.vue";
import api from "../../service/api";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  components: {YimoVueEditor},
  name: "CreatePart2_2",
  data() {
    return {
      number: 0,
      student: {},
      std_id: "",
      lbl_address: "",
      lbl_contry: "",
      selected_occup_type: "",
      selected_mfii: "",
      qn_mfii_txt: "",
      selected_talent: "",
      current_department_name: "",
      selected_work_type: "",
      qn_occup_type_txt: "",
      qn_work_status: "",
      qn_talent_txt: "",
      selected_work_satisfy: "",
      qn_work_satisfy_txt: "",
      selected_time_findwork: "",
      selected_match_edu: "",
      selected_apply_edu: "",
      select_other: 0,
      selected_work_success1: "",
      selected_work_success2: "",
      selected_work_success3: "",
      qn_work_success1_txt: "",
      qn_work_success2_txt: "",
      qn_work_success3_txt: "",
      selected_require_edu: "",
      sex: "",
      thai_student: "",
      current_erorrtxt: "",
      dangerModal: false,
      current_position: "",
      current_no: "",
      current_village: "",
      current_moo: "",
      current_lane: "",
      current_road: "",
      current_zipcode: "",
      current_address: "",
      current_building: "",
      current_tel: "",
      current_fax: "",
      current_email: "",
      current_salary: "",
      start: 0,
      items: [],
      // item2: [],
      item1s: [],
      items2: [],
      item2s: [],
      item3s: [],
      current_office: "",
      select_position: 0,
      select_position1: "",
      positionItems: [],
      countryItems: [],
      select_province: 0,
      current_province: "",
      provinceItems: [],
      select_district: 0,
      current_district: "",
      districtItems: [],
      select_subdistrict: 0,
      current_subdistrict: "",
      select_subdistrict_name: "",
      subdistrictItems: [],
      select_country: "",
      select_country1: "",
      select_country_name: "",
      select_country_name_eng: "",
      actionUpdate: 10,
      w_success1: 0,
      w_success2: 0,
      w_success3: 0,
    };
  }, computed: {
    validation_zipcode() {
      // console.log("current_zipcode==",this.current_zipcode.toString().length)
      if (this.current_zipcode != null && this.current_zipcode != '' && this.current_zipcode != undefined) {
        var substring = "-";
        if (this.current_zipcode.toString().length >= 1 && this.current_zipcode.toString().length <= 7) {
          if (this.current_zipcode.toString().includes(substring)) {
            // console.log("มี-")
            return false;
          } else {
            // console.log("ไม่มี-")
            if ((this.current_zipcode <= 9999999) && (this.current_zipcode >= 1)) {
              return true;
            } else {
              return false;
            }
          }
        } else {
          // console.log("f")
          return false;
        }
      } else {
        return false;
      }
    },
 /*   validation_email(){
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const thaiCharRegex = /[ก-ฮ]/;
      if (this.current_email=='-@gmail.com' || this.current_email=='-@lamduan.mfu.ac.th'
        || this.current_email=='-@yahoo.com' || this.current_email=='-@hotmail.com'
        || this.current_email=='-@hotmail.co.th' || this.current_email==='None'   ){
        return false;
      }else {
        if (this.current_email != null && this.current_email != '' && this.current_email != undefined) {
          if (!emailRegex.test(this.current_email)) {
            return false;
          } else if (thaiCharRegex.test(this.current_email)) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      }
    },*/

    validation_email() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/; // TLD ต้องมีอย่างน้อย 2 ตัวอักษร
      const thaiCharRegex = /[ก-ฮ]/;
      if (this.current_email == '-@gmail.com'
        || this.current_email == '-@lamduan.mfu.ac.th'|| this.current_email == '-@mfu.ac.th'
        || this.current_email == '-@yahoo.com' || this.current_email == '-@hotmail.com'
        || this.current_email == '-@hotmail.co.th' || this.current_email === 'None') {
        // console.log("542");
        return false;
      } else {
        if (this.current_email != null && this.current_email != '' && this.current_email != undefined) {
          if (this.current_email.endsWith('@lamduan.mfu.ac.th') || this.current_email.endsWith('@mfu.ac.th')
            || this.current_email.endsWith('@gmail.com') || this.current_email.endsWith('@yahoo.com')
          || this.current_email.endsWith('@hotmail.com') || this.current_email.endsWith('@hotmail.co.th')
          || this.current_email.endsWith('@outlook.com')) {
            return true;
          } else {
            return false;
          }
          if (!emailRegex.test(this.current_email)) {
            // console.log("547");
            return false;
          } else if (thaiCharRegex.test(this.current_email)) {
            // console.log("550");
            return false;
          } else {
            // console.log("553");
            return true;
          }
        } else {
          // console.log("557");
          return false;
        }
      }
    },
    validation_salary() {
      var comma_string = ",";
      if (this.current_salary != null && this.current_salary != undefined && this.current_salary != '' && this.current_salary !=0) {
        if ((this.current_salary.toString().length >= 4) && (this.current_salary.toString().length <= 7)) {
          if (this.current_salary.toString().includes(comma_string)) {
            return false;
          } else {
            if (this.validSalary()) {
              return true;
            } else {
              return false;
            }
          }
        } else {
          return false;
        }

      } else {
        return false;
      }
    },
    /*validation_email() {
      // var re = /^(([^<>()\[\]\\.,;:\s@"](\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var re = /^(([^<>()\[\]\\.,;:\s@"](\.[^<>()\[\]\\.,;:\s@"]+)*);
      if (this.current_email != null) {current_email
        if ( this.current_email.length >= 5 && this..length < 50){

          console.log("validEmail==",this.current_email,this.current_email.match(re) );
        }else{
          return false;
        }
        // if (re.test(this.current_email)){
        //   return true;
        // }else{
        //   return false;
        // }
      } else {
        return false;
      }
      console.log("validEmail==",email,re.test(email));
      // return re.test(email);
    }, */

    validation_fax() {
      // fax มี - ได้
      var substring = "-";
      var spacestring = " ";
      var zerochar = "00000";
      if (this.current_fax != null && this.current_fax != '' && this.current_fax != undefined) {
        if (this.current_fax == "-") {
          return true;
        }
        // console.log("select_country===", this.select_country)
        if (this.select_country == 'TH') {
          if (this.current_fax.toString().length >= 9) {
            if ((this.current_fax.toString().includes(substring)) || (this.current_fax.toString().includes(spacestring)) || (this.current_fax.toString().includes(zerochar))) {
              return false;
            } else {
              if (this.current_fax.toString().length > 0) {
                if (this.validFax(this.current_fax)) {
                  return true;
                } else {
                  return false;
                }
              } else {
                return false;
              }
            }
          } else {
            return false;
          }
        } else {
          if (this.current_fax.toString().length >= 9 && this.current_fax.toString().length <= 30) {
            if ((this.current_fax.toString().includes(spacestring)) || (this.current_fax.toString().includes(zerochar))) {
              // console.log("substring");
              return false;
            } else {
              if (this.current_fax.toString().length > 0) {
                // console.log("this.validPhone() ==", this.validFax(this.current_fax));
                if (this.validFax(this.current_fax)) {
                  return true;
                } else {
                  return false;
                }
              } else {
                return false;
              }
            }
          } else {
            return false;
          }
        }
      } else {
        return false;
      }
    },
    validation_teleng() {
      var substring = "-";
      var spacestring = " ";
      var zerochar = "00000";
      // console.log("tel==", this.current_tel)
      if (this.current_tel != null && this.current_tel != '' && this.current_tel != undefined) {
        if (this.current_tel.toString().length > 9 && this.current_tel.toString().length <= 30) {
          if ((this.current_tel.toString().includes(substring)) || (this.current_tel.toString().includes(spacestring)) || (this.current_tel.toString().includes(zerochar))) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    validation_tel() {
      var substring = "-";
      var spacestring = " ";
      var zerochar = "00000";
      if (this.current_tel != null && this.current_tel != '' && this.current_tel != undefined) {
        if (this.select_country == 'TH') {
          if (this.current_tel.toString().length == 10 || this.current_tel.toString().length == 9) {
            if ((this.current_tel.toString().includes(substring)) || (this.current_tel.toString().includes(spacestring)) || (this.current_tel.toString().includes(zerochar))) {
              return false;
            } else {
              // console.log("this.validPhone() ==", this.validPhone());
              if (this.validPhone()) {
                return true;
              } else {
                return false;
              }
            }
          } else {
            return false;
          }

        } else {
          if (this.current_tel.toString().length >= 9 && this.current_tel.toString().length <= 30) {
            if ((this.current_tel.toString().includes(substring)) || (this.current_tel.toString().includes(spacestring)) || (this.current_tel.toString().includes(zerochar))) {
              return false;
            } else {
              // console.log("this.validPhone() ==", this.validPhone());
              if (this.validPhone()) {
                return true;
              } else {
                return false;
              }
            }
          } else {
            return false;
          }
        }
      } else {
        return false;
      }
    },
    validation_job() {
      if (this.current_position != null && this.current_position != '' && this.current_position != undefined) {
        return this.current_position.length >= 5 && this.current_position.length < 50
      } else {
        return false;
      }
    },
    validation_office() {
      if (this.current_office != null && this.current_office != '' && this.current_office != undefined) {
        return this.current_office.length >= 3 && this.current_office.length < 100
      } else {
        return false;
      }
    },
    validation_department() {
      if (this.current_department_name != null && this.current_department_name != '' && this.current_department_name != undefined) {
        return this.current_department_name.length >= 3 && this.current_department_name.length < 100
      } else {
        return false;
      }
    },
    validation_no() {
      var bracket_open = "(";
      var bracket_close = ")";
      var square = "#";
      var star = "*";
      if (this.current_no != null && this.current_no != "" && this.current_no != undefined) {
        if ((this.current_no > 1) || (this.current_no < 9999999)) {
          return true;
        } else if (this.current_no == "-") {
          return true;
        } else {
          if (this.current_no.toString().length == 0) {
            return false;
          } else {
            if (this.current_no.includes(bracket_open) || this.current_no.includes(bracket_close)
              || this.current_no.includes(square) || this.current_no.includes(star)) {
              return false;
            } else if (this.current_no.includes('/') || this.current_no.includes('-')) {
              return true;
            }

          }
        }
        } else {
          return false;
      }

    },
    validation_village() {
      if (this.current_village != null && this.current_village != '' && this.current_village != undefined) {
        return this.current_village.length >= 1 && this.current_village.length < 50
      } else {
        return false;
      }
    },
    validation_build() {
      if (this.current_building != null && this.current_building != '' && this.current_building != undefined) {
        return this.current_building.length >= 1 && this.current_building.length < 50
      } else {
        return false;
      }
    },
    validation_road() {
      if (this.current_road != null && this.current_road != '' && this.current_road != undefined) {
        return this.current_road.length >= 1 && this.current_road.length < 50
      } else {
        return false;
      }
    },
    validation_province() {
      if (this.current_province != null && this.current_province != null && this.current_province != undefined) {
        return this.current_province.length >= 1 && this.current_province.length < 50
      } else {
        return false;
      }
    },
    validation_district() {
      // console.log("validation_district==",this.current_district.length)
      if (this.current_district != null && this.current_district != '' && this.current_district != undefined) {
        return this.current_district.length >= 1 && this.current_district.length < 50
      } else {
        return false;
      }
    },
    validation_subdistrict() {
      if (this.current_subdistrict != null) {
        return this.current_subdistrict.length >= 1 && this.current_subdistrict.length < 50
      } else {
        return false;
      }
    },
    validation_soi() {
      if (this.current_lane != null && this.current_lane != '' && this.current_lane != undefined) {
        return this.current_lane.length >= 1 && this.current_lane.length < 50
      } else {
        return false;
      }
    },
    validation_moo() {
      if (this.current_moo != null && this.current_moo != '' && this.current_moo != undefined)  {
        return this.current_moo.length >= 1 && this.current_moo.length < 50
      } else {
        return false;
      }
    },
    validAddress() {
      if (this.current_address != null) {
        return this.current_address.length >= 10 && this.current_address.length < 300
      } else {
        return false;
      }
    }

  },
  components: {
    vSelect
  },
  methods: {

    onBack() {
      this.$router.push("/Part2");
    },
   /* validEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const thaiCharRegex = /[ก-ฮ]/;
        if (email=='-@gmail.com' || email=='-@lamduan.mfu.ac.th'
          || email=='-@yahoo.com' || email=='-@hotmail.com'
          || email=='-@hotmail.co.th'|| email=='None'  ){
          return false;
        }else {
          if (email != null && email != '' && email != undefined) {
            if (!emailRegex.test(email)) {
              return false;
            } else if (thaiCharRegex.test(email)) {
              return false;
            } else {
              return true;
            }
          } else {
            return false;
          }
        }
    }, */
    validEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/; // TLD ต้องมีอย่างน้อย 2 ตัวอักษร
      const thaiCharRegex = /[ก-ฮ]/;
      if (email == '-@gmail.com'
        || email == '-@lamduan.mfu.ac.th'|| email == '-@mfu.ac.th'
        || email == '-@yahoo.com' || email == '-@hotmail.com'
        || email == '-@hotmail.co.th' || email=== 'None') {
        // console.log("--542");
        return false;
      } else {
        if (email!= null && email != '' && email != undefined) {
          if (email.endsWith('@lamduan.mfu.ac.th') || email.endsWith('@mfu.ac.th')
            || email.endsWith('@gmail.com') || email.endsWith('@yahoo.com')
            || email.endsWith('@hotmail.com') || email.endsWith('@hotmail.co.th')
            || email.endsWith('@outlook.com')) {
            return true;
          } else {
            // ไม่ใช่
            return false;
          }
          if (!emailRegex.test(email)) {
            // console.log("--547");
            return false;
          } else if (thaiCharRegex.test(email)) {
            // console.log("--550");
            return false;
          } else {
            // console.log("--553");
            return true;
          }
        } else {
          // console.log("--557");
          return false;
        }
      }
    },
    chackString(st) {
      if (st != null) {
        if (st == "-") {
          return true;
        } else {
          if (st.includes("-")) {
            console.log("--")
            return false;
          }
          if (st.includes("*")) {
            console.log("*")
            return false;
          }
          if (st.includes("&")) {
            console.log("&")
            return false;
          }
          if (st.includes("%")) {
            console.log("%")
            return false;
          }
          if (st.includes("$")) {
            console.log("$")
            return false;
          }
        }

      } else {
        return false;
      }
    },
    validFax(fax) {
      // console.log("fax==",fax)
      //() + #
      //var phoneno = /^\(?([0-9]{2})\)?[-]?([0-9]{4})[-]?([0-9]{4})$/; // /^\d{10}$/;  // /^[0-9]\d{2}-\d{3}-\d{4}$/;
      var phoneno_t9 = /^\d{9}$/;
      var phoneno_t10 = /^\d{10}$/;
      var phoneno1 = /^[+]{1}$/;
      var phoneno9 = /^\d{9}$/;
      var phoneno10 = /^\d{10}$/;
      var phoneno11 = /^\d{11}$/;
      var phoneno12 = /^\d{12}$/;
      var phoneno13 = /^\d{13}$/;
      var phoneno14 = /^\d{14}$/;
      var phoneno15 = /^\d{15}$/;
      var phoneno16 = /^\d{16}$/;
      var phoneno17 = /^\d{17}$/;
      var phoneno18 = /^\d{18}$/;
      var phoneno19 = /^\d{19}$/;
      var phoneno20 = /^\d{20}$/;
      var phoneno21 = /^\d{21}$/;
      var phoneno22 = /^\d{22}$/;
      var phoneno23 = /^\d{23}$/;
      var phoneno24 = /^\d{24}$/;
      var phoneno25 = /^\d{25}$/;
      var phoneno26 = /^\d{26}$/;
      var phoneno27 = /^\d{27}$/;
      var phoneno28 = /^\d{28}$/;
      var phoneno29 = /^\d{29}$/;
      var phoneno30 = /^\d{30}$/;
      var number = 0;
      // console.log("xx==", this.chackString(this.current_fax));
      if (fax == '-') {
        // console.log("true=837");
        return true;
      } else {
        if (fax == 'TH') {
          if (fax.match(phoneno_t9) || fax.match(phoneno_t10)) {
            // console.log("true=841");
            return true;
          } else {
            // console.log("false=844");
            return false;
          }
        } else {
          // console.log("string_plus=", this.current_fax);
          var x = "";
          var string_plus = "+";
          var string_open = "(";
          var string_end = ")";
          var string_sharp = "#";
          var have_string = 0;
          if (fax.includes(string_plus) || fax.includes(string_open) ||
            fax.includes(string_end) || fax.includes(string_sharp)) {
            // console.log("t==857");
            x = fax.replace(string_plus, "")
            x = x.replace(string_open, "")
            x = x.replace(string_end, "")
            x = x.replace(string_sharp, "")
            // console.log("x==", x);
            have_string = 1;
            return true;
          } else {
            have_string = 0;
          }

          if (have_string == 1) {
            if (x.match(phoneno9) || x.match(phoneno10) || x.match(phoneno11) || x.match(phoneno12) || x.match(phoneno14)
              || x.match(phoneno15) || x.match(phoneno16) || x.match(phoneno17) || x.match(phoneno18)
              || x.match(phoneno19) || x.match(phoneno20) || x.match(phoneno21) || x.match(phoneno22)
              || x.match(phoneno23) || x.match(phoneno24) || x.match(phoneno25) || x.match(phoneno26)
              || x.match(phoneno27) || x.match(phoneno28) || x.match(phoneno29) || x.match(phoneno30)) {
              // console.log("t==875");
              return true;
            } else {
              // console.log("f==878");
              return false;
            }
          } else {
            if (fax.match(phoneno9) || fax.match(phoneno10) || fax.match(phoneno11) || fax.match(phoneno12) || fax.match(phoneno14)
              || fax.match(phoneno15) || fax.match(phoneno16) || fax.match(phoneno17) || fax.match(phoneno18)
              || fax.match(phoneno19) || fax.match(phoneno20) || fax.match(phoneno21) || fax.match(phoneno22)
              || fax.match(phoneno23) || fax.match(phoneno24) || fax.match(phoneno25) || fax.match(phoneno26)
              || fax.match(phoneno27) || fax.match(phoneno28) || fax.match(phoneno29) || fax.match(phoneno30)) {
              // console.log("t==887");
              return true;
            } else {
              // console.log("f==890");
              return false;
            }
          }
        }
      }

    },
    validPhone() {
      //() + #
      //var phoneno = /^\(?([0-9]{2})\)?[-]?([0-9]{4})[-]?([0-9]{4})$/; // /^\d{10}$/;  // /^[0-9]\d{2}-\d{3}-\d{4}$/;
      var phoneno_t9 = /^\d{9}$/;
      var phoneno_t10 = /^\d{10}$/;
      // var phoneno1 = /^\(?([0-9]{2})\)?[-]?([0-9]{4})[-]?([0-9]{4})$/;
      var phoneno1 = /^[+]{1}$/;
      var phoneno9 = /^\d{9}$/;
      var phoneno10 = /^\d{10}$/;
      var phoneno11 = /^\d{11}$/;
      var phoneno12 = /^\d{12}$/;
      var phoneno13 = /^\d{13}$/;
      var phoneno14 = /^\d{14}$/;
      var phoneno15 = /^\d{15}$/;
      var phoneno16 = /^\d{16}$/;
      var phoneno17 = /^\d{17}$/;
      var phoneno18 = /^\d{18}$/;
      var phoneno19 = /^\d{19}$/;
      var phoneno20 = /^\d{20}$/;
      var phoneno21 = /^\d{21}$/;
      var phoneno22 = /^\d{22}$/;
      var phoneno23 = /^\d{23}$/;
      var phoneno24 = /^\d{24}$/;
      var phoneno25 = /^\d{25}$/;
      var phoneno26 = /^\d{26}$/;
      var phoneno27 = /^\d{27}$/;
      var phoneno28 = /^\d{28}$/;
      var phoneno29 = /^\d{29}$/;
      var phoneno30 = /^\d{30}$/;
      var number = 0;
      if (this.select_country == 'TH') {
        if (this.current_tel.match(phoneno_t9) || this.current_tel.match(phoneno_t10)) {
          // console.log("true=", this.current_tel);
          return true;
        } else {
          // console.log("false=", this.current_tel);
          return false;
        }
      } else {
        var string_plus = "+";
        var string_open = "(";
        var string_end = ")";
        var string_sharp = "#";
        var have_string = 0;
        if (this.current_tel.includes(string_plus) || this.current_tel.includes(string_open) ||
          this.current_tel.includes(string_end) || this.current_tel.includes(string_sharp)) {
          // console.log("t==", this.current_tel);
          var x = this.current_tel.replace(string_plus, "")
          x = x.replace(string_open, "")
          x = x.replace(string_end, "")
          x = x.replace(string_sharp, "")
          // console.log("x==", x);
          have_string = 1;
          return true;
        }

        if (have_string = 1) {
          if (x.match(phoneno9) || x.match(phoneno10) || x.match(phoneno11) || x.match(phoneno12)|| x.match(phoneno13)  || x.match(phoneno14)
            || x.match(phoneno15) || x.match(phoneno16) || x.match(phoneno17) || x.match(phoneno18)
            || x.match(phoneno19) || x.match(phoneno20) || x.match(phoneno21) || x.match(phoneno22)
            || x.match(phoneno23) || x.match(phoneno24) || x.match(phoneno25) || x.match(phoneno26)
            || x.match(phoneno27) || x.match(phoneno28) || x.match(phoneno29) || x.match(phoneno30)) {
            // console.log("t==",this.current_tel);
            return true;
          } else {
            // console.log("f==", this.current_tel);
            return false;
          }
        } else {

          if (this.current_tel.match(phoneno9) || this.current_tel.match(phoneno10) || this.current_tel.match(phoneno11) || this.current_tel.match(phoneno12) || this.current_tel.match(phoneno13) || this.current_tel.match(phoneno14)
            || this.current_tel.match(phoneno15) || this.current_tel.match(phoneno16) || this.current_tel.match(phoneno17) || this.current_tel.match(phoneno18)
            || this.current_tel.match(phoneno19) || this.current_tel.match(phoneno20) || this.current_tel.match(phoneno21) || this.current_tel.match(phoneno22)
            || this.current_tel.match(phoneno23) || this.current_tel.match(phoneno24) || this.current_tel.match(phoneno25) || this.current_tel.match(phoneno26)
            || this.current_tel.match(phoneno27) || this.current_tel.match(phoneno28) || this.current_tel.match(phoneno29) || this.current_tel.match(phoneno30)) {
            // console.log("t==",this.current_tel);
            return true;
          } else {
            // console.log("f==", this.current_tel);
            return false;
          }
        }
      }
    },
    validZipcode() {
      // console.log("current_zipcode==",this.current_zipcode.toString().length)
      if (this.current_zipcode != null && this.current_zipcode != '' && this.current_zipcode != undefined) {
        var substring = "-";
        if (this.current_zipcode.toString().length >= 1 && this.current_zipcode.toString().length <= 7) {
          if (this.current_zipcode.toString().includes(substring)) {
            // console.log("มี-")
            return false;
          } else {
            // console.log("ไม่มี-")
            if ((this.current_zipcode <= 9999999) && (this.current_zipcode >= 1)) {
              return true;
            } else {
              return false;
            }
          }
        } else {
          // console.log("f")
          return false;
        }
      } else {
        return false;
      }
    },
    validSalary() {
      var salary3 = /^\d{3}$/;
      var salary4 = /^\d{4}$/;
      var salary5 = /^\d{5}$/;
      var salary6 = /^\d{6}$/;
      var salary7 = /^\d{7}$/;
      if (this.current_salary.match(salary3) || this.current_salary.match(salary4) || this.current_salary.match(salary5) || this.current_salary.match(salary6) || this.current_salary.match(salary7)) {
        return true;
      } else {
        return false;
      }
    },
    isNumeric: function (n) {
      if ((n > 999) || (n <= 9999999)) {
        return true;
      } else {
        return false;
      }
    },
    getCurrentStudent(studentid) {
      api
        .getStudentGeneral(studentid)
        .then(res => {
          // console.log("-------res----------",res.data.data);
          if (res.data.data.length > 0) {
            this.actionUpdate = 1;
            var currentSt = res.data.data[0];
            this.std_id = this.student.STUDENTID;
            // this.qn_work_nation = currentSt.QN_WORK_NATION;
            // console.log("qn_work_nation", this.qn_work_nation);
            this.select_country1 = currentSt.QN_WORK_NATION_NAME; //ดึงชื่อประเทศ ที่เลือก ขึ้น dropdown
            this.select_country_name = currentSt.QN_WORK_NATION_NAME;
            this.select_country = currentSt.QN_WORK_NATION
            this.current_no = currentSt.QN_WORK_ADD;
            this.current_moo = currentSt.QN_WORK_MOO;
            this.current_building = currentSt.QN_WORK_BUILDING;
            this.current_lane = currentSt.QN_WORK_SOI;
            this.current_road = currentSt.QN_WORK_STREET;
            this.current_zipcode = currentSt.QN_WORK_ZIPCODE;
            // console.log("QN_WORK_NATION", currentSt.QN_WORK_NATION, "==", this.select_country_name);
            this.current_subdistrict = currentSt.QN_WORK_TAMBON_NAME
            this.current_district = currentSt.QN_WORK_DISTRICT_NAME
            this.current_province = currentSt.QN_WORK_PROVINCE_NAME
            if (currentSt.QN_WORK_NATION == 'TH') {
              this.select_province = currentSt.QN_WORK_PROVINCE;
              this.onloadDistrictById(this.select_province, this.thai_student);
              this.select_district = currentSt.QN_WORK_DISTRICT;
              this.select_subdistrict = currentSt.QN_WORK_TAMBON;
              this.select_subdistrict_name = currentSt.QN_WORK_TAMBON_NAME;
              this.onloadSubDistrictById(this.select_district, this.thai_student);
            } else {
              // this.current_subdistrict = currentSt.QN_WORK_TAMBON_NAME
              // this.current_district = currentSt.QN_WORK_DISTRICT_NAME
              // this.current_province = currentSt.QN_WORK_PROVINCE_NAME
            }
            this.current_tel = currentSt.QN_WORK_TEL;
            this.current_fax = currentSt.QN_WORK_FAX;
            // console.log("email==",currentSt.QN_WORK_EMAIL)
            if ((currentSt.QN_WORK_EMAIL == '') || (currentSt.QN_WORK_EMAIL == null) || (currentSt.QN_WORK_EMAIL == undefined)) {
              this.current_email = currentSt.CURRENT_EMAIL;
            } else {
              this.current_email = currentSt.QN_WORK_EMAIL;
            }
            // console.log("1020==", currentSt.QN_SALARY)
            /*this.current_salary = currentSt.QN_SALARY;
            this.selected_work_satisfy = currentSt.QN_WORK_SATISFY;
            this.qn_work_satisfy_txt = currentSt.QN_WORK_SATISFY_TXT;
            this.selected_time_findwork = currentSt.QN_TIME_FINDWORK;
            this.selected_match_edu = currentSt.QN_MATCH_EDU;
            this.selected_apply_edu = currentSt.QN_APPLY_EDU;
            this.selected_work_success1 = currentSt.WORK_SUCCESS1;
            this.selected_work_success2 = currentSt.WORK_SUCCESS2;
            this.selected_work_success3 = currentSt.WORK_SUCCESS3;

            this.qn_work_success1_txt = currentSt.WORK_SUCCESS_TEXT1;
            this.qn_work_success2_txt = currentSt.WORK_SUCCESS_TEXT2;
            this.qn_work_success3_txt = currentSt.WORK_SUCCESS_TEXT3;
            this.selected_require_edu = currentSt.QN_REQUIRE_EDU;*/
            this.getCountry(this.thai_student);
          } else {
            this.actionUpdate = 0;
          }
        })
        .catch(err => {
          this.actionUpdate = 10;
          console.log("getCurrentStudent", err.toString());
          // this.$router.push("Logout");
        });
      // console.log("actionUpdate==", this.actionUpdate);
    },
    getStudentQuestion() {
      this.std_id = this.$store.state.user.studentid;
      this.stdstudentId = this.$store.state.user.studentid;
      this.thai_student = this.$store.state.user.thaistudent;
      this.sex = this.$store.state.user.sex;
      // var start = parseInt(this.$route.query.x);
      // const x = parseInt(this.$route.query.x);
      // const start = x > 0 ? x : 0;
      // this.start = start + 1;
      var x = this.$route.query.x;
      var start = 0;
      console.log("x==", isNaN(x));
      if (isNaN(x) || x <= 0) {
        start = 0;
      } else {
        start = parseInt(x)-1;
      }
      this.getQuestion(21, this.sex, this.thai_student, start);// ที่อยู่
      this.getProvince(this.thai_student);
      this.onloadDistrictById(this.select_province, this.thai_student);
      this.getPosition();
    },
    setStudent() {
      var student = {};
      student.std_id = this.$store.state.user.studentid;
      student.qn_year = this.$store.state.user.year;
      student.select_country_name = this.select_country_name;
      student.select_country = this.select_country;
      // console.log("student==", student);
      if ((this.select_country == null) || (this.select_country == '') || (this.select_country == undefined)) {
        this.items2[6].VALUES = 2;
      } else {
        this.items2[6].VALUES = 1;
      }
      student.select_country_name = this.select_country_name;
      student.current_no = this.current_no;
      if ((this.current_no == null) || (this.current_no == '') || (this.current_no == undefined)) {
        this.items2[1].VALUES = 2;
      } else {
        this.items2[1].VALUES = 1;
      }
      student.current_moo = this.current_moo
      //.replaceAll( "'", "`");
      if ((this.current_moo == null) || (this.current_moo == '') || (this.current_moo == undefined)) {
        this.items2[2].VALUES = 2;
      } else {
        this.items2[2].VALUES = 1;
      }
      student.current_building = this.current_building
      //.replaceAll( "'", "`");
      if ((this.current_building == null) || (this.current_building == '') || (this.current_building == undefined)) {
        this.items2[3].VALUES = 2;
      } else {
        this.items2[3].VALUES = 1;
      }
      student.current_lane = this.current_lane
      //.replaceAll( "'", "`");
      if ((this.current_lane == null) || (this.current_lane == '') || (this.current_lane == undefined)) {
        this.items2[4].VALUES = 2;
      } else {
        this.items2[4].VALUES = 1;
      }
      student.current_road = this.current_road
      //.replaceAll( "'", "`");
      if ((this.current_road == null) || (this.current_road == '') || (this.current_road == undefined)) {
        this.items2[5].VALUES = 2;
      } else {
        this.items2[5].VALUES = 1;
      }
      student.current_zipcode = this.current_zipcode;

      if ((this.current_zipcode == null) || (this.current_zipcode == '') || (this.current_zipcode == undefined)) {
        this.items2[9].VALUES = 2;
      } else {
        this.items2[9].VALUES = 1;
      }
      if (this.select_country == 'TH') {
        student.select_province = this.select_province;
        student.current_province = this.current_province;
        if ((this.select_province == null) || (this.select_province == '') || (this.select_province == undefined)) {
          this.items2[6].VALUES = 2;
        } else {
          this.items2[6].VALUES = 1;
        }
        student.select_district = this.select_district;
        student.current_district = this.current_district
        if ((this.select_district == null) || (this.select_district == '') || (this.select_district == undefined)) {
          this.items2[7].VALUES = 2;
        } else {
          this.items2[7].VALUES = 1;
        }
        student.select_subdistrict = this.select_subdistrict;
        student.current_subdistrict = this.current_subdistrict
        if ((this.select_subdistrict == null) || (this.select_subdistrict == '') || (this.select_subdistrict == undefined)) {
          this.items2[8].VALUES = 2;
        } else {
          this.items2[8].VALUES = 1;
        }
        student.select_subdistrict_name = this.select_subdistrict_name;
        // this.student.current_address = "";
      } else {
        student.current_province = this.current_province
        //.replaceAll( "'", "`");
        if ((this.current_province == null) || (this.current_province == '') || (this.current_province == undefined)) {
          this.items2[6].VALUES = 2;
        } else {
          this.items2[6].VALUES = 1;
        }
        student.current_district = this.current_district
        //.replaceAll( "'", "`");
        if ((this.current_district == null) || (this.current_district == '') || (this.current_district == undefined)) {
          this.items2[7].VALUES = 2;
        } else {
          this.items2[7].VALUES = 1;
        }
        if (this.current_subdistrict !=null && this.current_subdistrict !='' && this.current_subdistrict !=undefined ) {
          student.current_subdistrict = this.current_subdistrict.replaceAll("'", "`");
        }
        if ((this.current_subdistrict == null) || (this.current_subdistrict == '') || (this.current_subdistrict == undefined)) {
          this.items2[8].VALUES = 2;
        } else {
          this.items2[8].VALUES = 1;
        }
      }
      student.current_tel = this.current_tel;
      // student.current_tel = "";
      this.items2[10].VALUES = 1;
      if ((this.current_tel == null) || (this.current_tel == '') || (this.current_tel == undefined)) {
        this.items2[10].VALUES = 2;
      } else {
        this.items2[10].VALUES = 1;
      }
      student.current_fax = this.current_fax;
      // student.current_fax = "";
      this.items2[11].VALUES = 1;
      if ((this.current_fax == null) || (this.current_fax == '') || (this.current_fax == undefined)) {
        this.items2[11].VALUES = 2;
      } else {
        this.items2[11].VALUES = 1;
      }
      // console.log("current_fax==", this.items2[11]);
      student.current_email = this.current_email;
      // student.current_email = ""
      this.items2[12].VALUES = 1;
      if ((this.current_email == null) || (this.current_email == '') || (this.current_email == undefined)) {
        this.items2[12].VALUES = 2;
      } else {
        this.items2[12].VALUES = 1;
      }

      // console.log("setStudent==", student);
      return student;
    },
    checkQuotation(s) {
      var quotation1 = "'";
      var quotation2 = "`";
      // console.log("s==",s)
      if (s.current_village !=''&& s.current_village !=null && s.current_village!=undefined) {
        if (s.current_village.toString().length > 0) {
          if (s.current_village.toString().includes(quotation1)) {
            s.current_village = s.current_village.replaceAll(quotation1, "''");
          }
          if (s.current_village.toString().includes(quotation2)) {
            s.current_village = s.current_village.replaceAll(quotation2, "''");
          }
        }
      }
      if (s.current_building !=''&& s.current_building !=null && s.current_building!=undefined) {
        if (s.current_building.toString().length > 0) {
          if (s.current_building.toString().includes(quotation1)) {
            s.current_building = s.current_building.replaceAll(quotation1, "''");
          }
          if (s.current_building.toString().includes(quotation2)) {
            s.current_building = s.current_building.replaceAll(quotation2, "''");
          }
        }
      }
      if (s.current_road !=''&& s.current_road !=null && s.current_road!=undefined) {
        if (s.current_road.toString().length > 0) {
          if (s.current_road.toString().includes(quotation1)) {
            s.current_road = s.current_road.replaceAll(quotation1, "''");
          }
          if (s.current_road.toString().includes(quotation2)) {
            s.current_road = s.current_road.replaceAll(quotation2, "''");
          }
        }
      }
      if (s.current_lane !=''&& s.current_lane !=null && s.current_lane!=undefined) {
        if (s.current_lane.toString().length > 0) {
          if (s.current_lane.toString().includes(quotation1)) {
            s.current_lane = s.current_lane.replaceAll(quotation1, "''");
          }
          if (s.current_lane.toString().includes(quotation2)) {
            s.current_lane = s.current_lane.replaceAll(quotation2, "''");
          }
        }
      }

      if (s.current_moo !='' && s.current_moo!=null && s.current_moo!= undefined) {
        if (s.current_moo.toString().length > 0) {
          if (s.current_moo.includes(quotation1)) {
            s.current_moo = s.current_moo.replaceAll(quotation1, "''");
          }
          if (s.current_moo.toString().includes(quotation2)) {
            s.current_moo = s.current_moo.replaceAll(quotation2, "''");
          }
        }
      }
      if (s.current_address !='' && s.current_address!=null && s.current_address!= undefined) {
        if (s.current_address.toString().length > 0) {
          if (s.current_address.toString().includes(quotation1)) {
            s.current_address = s.current_address.replaceAll(quotation1, "''");
          }
          if (s.current_address.toString().includes(quotation2)) {
            s.current_address = s.current_address.replaceAll(quotation2, "''");
          }
        }
      }
      if (s.current_province !='' && s.current_province!=null && s.current_province!= undefined) {
        if (s.current_province.toString().length > 0) {
          if (s.current_province.toString().includes(quotation1)) {
            s.current_province = s.current_province.replaceAll(quotation1, "''");
          }
          if (s.current_province.toString().includes(quotation2)) {
            s.current_province = s.current_province.replaceAll(quotation2, "''");
          }
        }
      }
      if (s.current_district !='' && s.current_district!=null && s.current_district!= undefined) {
        if (s.current_district.toString().length > 0) {
          if (s.current_district.toString().includes(quotation1)) {
            s.current_district = s.current_district.replaceAll(quotation1, "''");
          }
          if (s.current_district.toString().includes(quotation2)) {
            s.current_district = s.current_district.replaceAll(quotation2, "''");
          }
        }
      }
      if (s.current_subdistrict !='' && s.current_subdistrict!=null && s.current_subdistrict!= undefined) {
        if (s.current_subdistrict.toString().length > 0) {
          if (s.current_subdistrict.toString().includes(quotation1)) {
            s.current_subdistrict = s.current_subdistrict.replaceAll(quotation1, "''");
          }
          if (s.current_subdistrict.toString().includes(quotation2)) {
            s.current_subdistrict = s.current_subdistrict.replaceAll(quotation2, "''");
          }
        }
      }
      return s;
    },
    getErrorTxt: function (s) {
      this.current_erorrtxt = "";
      var substring = "--";
      var sub = "-";
      var zerochar = "00000";
      var slash = "/";
      var bracket_open = "(";
      var bracket_close = ")";
      var square = "#";
      var star = "*";
      var space = " ";
      // var after_no = this.current_no;
      // console.log("Before items2==",this.items2)
      this.numEror = 0;
      var student  =this.checkQuotation(s);
    if (this.current_no == "") {
        this.numEror = this.numEror + 1;
        this.items2[1].VALUES = 2;
        this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/เลขที่" : this.current_erorrtxt + "/Address number";
      }
      if (this.current_no != null && this.current_no != "" && this.current_no != undefined) {
        if ((this.current_no  > 1) || (this.current_no  < 9999999)) {
          // return true;
        } else if (this.current_no == "-") {
          // return true;
        } else {
          if (this.current_no.toString().length ==0){
            this.numEror = this.numEror + 1;
            this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/กรอกเลขที่เท่านั้น" : this.current_erorrtxt + "/Valid Number";
          }else{
            if (this.current_no.includes(bracket_open) || this.current_no.includes(bracket_close)
              || this.current_no.includes(square) || this.current_no.includes(star)){
              this.numEror = this.numEror + 1;
              this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/กรอกเลขที่เท่านั้น" : this.current_erorrtxt + "/Valid Number";
            }else if (this.current_no.includes('/') || this.current_no.includes('-') ){
              // return true;
            }
          }
        }
      } else {
        this.numEror = this.numEror + 1;
        this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/กรอกเลขที่เท่านั้น" : this.current_erorrtxt + "/Valid Number";
      }
      if (this.current_moo == "") {
        this.numEror = this.numEror + 1;
        this.items2[2].VALUES = 2;
        this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/หมู่" : this.current_erorrtxt + "/Moo";
      }
      if (this.current_building == "") {
        this.numEror = this.numEror + 1;
        this.items2[3].VALUES = 2;
        this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ตึก" : this.current_erorrtxt + "/Building";
      }
      if (this.current_lane == "") {
        this.numEror = this.numEror + 1;
        this.items2[4].VALUES = 2;
        this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ซอย" : this.current_erorrtxt + "/Soi";
      }
      if (this.current_road == "") {
        this.numEror = this.numEror + 1;
        this.items2[5].VALUES = 2;
        this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ถนน" : this.current_erorrtxt + "/Road";
      }
      if (this.select_country == 'TH') {
        if ((this.select_province == null) || (this.select_province == "")) {
          this.numEror = this.numEror + 1;
          this.items2[6].VALUES = 2;
          this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/จังหวัด" : this.current_erorrtxt + "/Province";
        }
        if ((this.select_district == null) || (this.select_district == "")) {
          this.numEror = this.numEror + 1;
          this.items2[7].VALUES = 2;
          this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/อำเภอ" : this.current_erorrtxt + "/District";
        }
        if ((this.select_subdistrict == null) || (this.select_subdistrict == "")) {
          this.numEror = this.numEror + 1;
          this.items2[8].VALUES = 2;
          this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ตำบล" : this.current_erorrtxt + "/Subdistrict";
        }
        if ((this.current_zipcode == null) || (this.current_zipcode == "") || (this.current_zipcode == undefined)){
          if (!this.validZipcode()) {
            this.numEror = this.numEror + 1;
            this.items2[8].VALUES = 2;
            this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/โทรศัพท์ที่ทำงาน ไม่เว้นวรรค ไม่มีสัญลักษณ์" : this.current_erorrtxt + "/Phone Number ";
          }
        }
      } else {
        if ((this.current_province == null) || (this.current_province == "") || (this.current_province == undefined)) {
          this.numEror = this.numEror + 1;
          this.items2[6].VALUES = 2;
          this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/จังหวัด" : this.current_erorrtxt + "/Province";
        }
        if ((this.current_district == null) || (this.current_district == "") || (this.current_district == undefined)) {
          this.numEror = this.numEror + 1;
          this.items2[7].VALUES = 2;
          this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/อำเภอ" : this.current_erorrtxt + "/District";
        }
        if ((this.current_subdistrict == null) || (this.current_subdistrict == "") || (this.current_subdistrict == undefined)) {
          this.numEror = this.numEror + 1;
          this.items2[8].VALUES = 2;
          this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ตำบล" : this.current_erorrtxt + "/Subdistrict";
        }
        if ((this.current_zipcode == null) || (this.current_zipcode == "") || (this.current_zipcode == undefined)){
          if (!this.validZipcode()) {
            this.numEror = this.numEror + 1;
            this.items2[8].VALUES = 2;
            this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/รหัสไปรษณีย์" : this.current_erorrtxt + "/Zipcode ";
          }
        }
      }

      if ((this.current_tel == null) || (this.current_tel == "")) {
        this.numEror = this.numEror + 1;
        this.items2[10].VALUES = 2;
        this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/โทรศัพท์ที่ทำงาน" : this.current_erorrtxt + "/Telephone No.";
      } else {
        if (this.select_country == 'TH') {
          if ((this.current_tel.length < 9)) {
            this.numEror = this.numEror + 1;
            this.items2[10].VALUES = 2;
            this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ประเทศไทย หมายเลขโทรศัพท์มี 9-10 ตัว" : this.current_erorrtxt + "/Phone Number ";
          }
          if (!this.validPhone()) {
            this.numEror = this.numEror + 1;
            this.items2[10].VALUES = 2;
            this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/โทรศัพท์ที่ทำงาน ไม่เว้นวรรค ไม่มีสัญลักษณ์" : this.current_erorrtxt + "/Phone Number ";
          }
          if (this.current_tel.includes(zerochar)) {
            this.numEror = this.numEror + 1;
            this.items2[10].VALUES = 2;
            this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/โทรศัพท์" : this.current_erorrtxt + "/Mobile Phone";
          }
        } else {
          // console.log("eng==", this.select_country);
          if ((this.current_tel.includes(substring) || this.current_tel.includes(sub)) || (this.current_tel.includes(space))
            || (this.current_tel.includes(zerochar)) || (this.current_tel.includes(slash)) || (this.current_tel.includes(bracket_open))
              || (this.current_tel.includes(bracket_close)) || (this.current_tel.includes(square)) || (this.current_tel.includes(star)) ) {
            // console.log("---");
            this.numEror = this.numEror + 1;
            this.items2[10].VALUES = 2;
            this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/โทรศัพท์ที่ทำงาน /()#*-" : this.current_erorrtxt + "/Telephone /()#*-";
          }
        }

      }
      if ((this.current_fax == null) || (this.current_fax == "")) {
        this.numEror = this.numEror + 1;
        this.items2[11].VALUES = 2;
        this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/โทรสารที่ทำงาน" : this.current_erorrtxt + "/Fax Number.";
      } else {
        if (!this.validFax(this.current_fax)) {
          this.numEror = this.numEror + 1;
          this.items2[11].VALUES = 2;
          this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/โทรสารที่ทำงาน ไม่เว้นวรรค ไม่มีสัญลักษณ์ " : this.current_erorrtxt + "/Fax Number ";
        }
      }

      if ((this.select_country == null) || (this.select_country == 0) || (this.select_country == "None")) {
        this.numEror = this.numEror + 1;
        this.items2[7].VALUES = 2;
        this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ประเทศ" : this.current_erorrtxt + "/Country";
      }
      // console.log("email ไม่ผ่าน==", this.current_email, this.validEmail(this.current_email));
      if (!this.validEmail(this.current_email)) {

        this.numEror = this.numEror + 1;
        this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ตรวจสอบอีเมล์" : this.current_erorrtxt + "/Valid email required";
      } else {
        var email_length = this.current_email.length;
        // console.log("email_length==",email_length);
        var new_email = this.current_email.substring(email_length - 2, email_length);
        // console.log("new_email==",new_email);
        if (new_email == 'co') {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = student.current_thai_student == "1" ? this.current_erorrtxt + "/co กรอกไม่ครบ" : this.current_erorrtxt + "/Valid email required";
        }
      }

      if (this.numEror == 0) {
        this.dangerModal = false;
      } else {
        this.dangerModal = true;
      }
      student.num_error= this.numEror;
      return  student
    }
    ,
    nextPart() {
      if (this.selected_require_edu == 1) {
        this.$router.push("/Part4?x=" + this.number);
      } else if (this.selected_require_edu == 2) {
        this.$router.push("/Part5?x=" + this.number);
      }
    },
    updatePart2_20(student) {
      api
        .updateStudentPart2_20(student)
        .then(res => {
          // console.log(this.student);
          this.message = res.message;
          if (res.data.code == 200) {
            this.$router.push("part2_3?x=" + this.number);
          } else {
            this.$router.push("part2?x=" + this.number);
          }
          // console.log("update ผ่าน", this.std_id);
          // this.nextPart();
        })
        .catch(err => {
          console.log("updatePart2 error", err.toString());
          // this.$router.push("Logout");
        });
    },
    updatePart2_21(student) {
      api
        .updateStudentPart2_21(student)
        .then(res => {
          // console.log(this.student);
          this.message = res.message;
          if (res.data.code == 200) {
            this.$router.push("part2_3?x=" + this.number);
          } else {
            this.$router.push("part2?x=" + this.number);
          }
          // console.log("update ผ่าน", this.std_id);
          // this.nextPart();
        })
        .catch(err => {
          console.log("updatePart2 error", err.toString());
          // this.$router.push("Logout");
        });
    }
    ,
    onReset() {
      this.selected_occup_type = "";
      this.selected_talent = "";
      this.qn_occup_type_txt = "";
      this.qn_talent_txt = "";
      // this.QN_POS_ID="";
      this.select_position1 = "";
      this.current_office = "";
      this.selected_work_type = "";
      this.select_country1 = "";
      this.current_tel = "";
      this.current_fax = "";
      this.current_email = "";
      this.current_salary = "";
      this.selected_work_satisfy = "";
      this.qn_work_satisfy_txt = "";
      this.selected_time_findwork = "";
      this.selected_match_edu = "";
      this.selected_require_edu = "";
      this.selected_apply_edu = "";
      this.current_address = "";
    },
    onSubmit() {
      var student = this.setStudent();
      var s = this.getErrorTxt(student);
      // console.log("this.student", this.student);
     if (s.num_error == 0) {
        if (this.actionUpdate == 1) {
          if (this.select_country == 'TH') {
            this.updatePart2_21(s);
          } else {
            this.updatePart2_20(s);
          }
        } else {
          this.$router.push("/general");
        }
      }
      // console.log("ansChoose=", this.ansChoose);
    }
    ,
    getQuestion(section, sex, thaistudent, start) {

      api
        .getQuestionBySection(section, sex, thaistudent, start)
        .then(res => {
          var number
          number = start + 1;
          this.number = start + length;

          for (var i = 0; i < res.data.data.length; i++) {
            number = number + 1;
            res.data.data[i].NUMBER = number;
          }
          this.item1s = res.data.data;
          this.number = number;
          // console.log("item1s=", this.item1s)
        })
        .catch(err => {
          console.log("2_2 getQuestionBySection", err.toString());
        });

    }
    ,
    getPosition() {
      api
        .getPositionAll()
        .then(res => {
          this.positionItems = res.data.data;
          // console.log("positionItems==", res.data.data);
        })
        .catch(err => {
          console.log("getPosition", err.toString());
        });
    }
    ,
    getPostionById(id) {
      this.positionItems.value = id;
      // api
      //   .getPositionAll()
      //   .then(res => {
      //     this.positionItems = res.data.data;
      //     // console.log("positionItems==", res.data.data);
      //   })
      //   .catch(err => {
      //     console.log("getPosition", err.toString());
      //   });
    }
    ,
    getCountry(thaistudent) {
      // console.log("thaistudent==",thaistudent);
      api
        .getCountryAll(thaistudent)
        .then(res => {
          this.countryItems = res.data.data;
          // console.log("countryItems==", this.countryItems);
        })
        .catch(err => {
          console.log(2);
          console.log("2", err.toString());
        });
    }
    ,
    getProvince(thaistudent) {
      api
        .getProvinceAll(thaistudent)
        .then(res => {
          this.provinceItems = res.data.data;
        })
        .catch(err => {
          console.log("getProvince", err.toString());
        });
    },
    getProvinceById(id, thai_student) {
      api
        .getProvinceById(id, thai_student)
        .then(res => {
          this.current_province = res.data.data[0].PROVINCENAME
          // console.log("getProvinceById==", this.current_province)
          // return
        })
        .catch(err => {
          console.log("getProvince", err.toString());
        });
    },
    selectProvinceOnchange: function (e) { //จังหวัด
      this.onloadDistrictById(this.select_province, this.thai_student);
      this.select_subdistrict = 0;
      // current_province
      this.getProvinceById(this.select_province, this.thai_student);
      // console.log("selectProvinceOnchange==", this.current_province);
    },
    getDistrictByDistrictid(id, thai_student) {
      api
        .getDistrictByDistrictid(id, thai_student)
        .then(res => {
          this.current_district = res.data.data[0].DISTRICTNAME;
          // console.log("getDistrictByDistrictid==", res.data.data[0].DISTRICTNAME)
        })
        .catch(err => {
          console.log("getProvince", err.toString());
        });
    },
    selectDistrictOnchange: function () { //อำเภอ
      // this.current_district = this.select_district;
      // console.log("select_district==", this.select_district);
      this.onloadSubDistrictById(this.select_district, this.thai_student);
      this.getDistrictByDistrictid(this.select_district, this.thai_student);
    },
    selectSubDistrictOnchange: function () { //ตำบล
      this.onloadZipcodeById(this.select_subdistrict);
    }
    ,
    selectPositionOnchange: function () {
      this.current_position = this.select_position1.POS_NAME;
      this.select_position = this.select_position1.POS_ID;
      // console.log("select_position==", this.select_position);
      // console.log("select_position_name==", this.current_position);
    },
    selectCountryOnchange(e) {
      // console.log("selectCountryOnchange", e);
      // this.select_country_name = this.select_country1.COUNTRYNAME;
      // this.select_country = this.select_country1.COUNTRYID;
      this.select_country_name = e.COUNTRYNAME;
      this.select_country = e.COUNTRYID;
      this.select_country_name_eng = e.NATION_NAME_ENG;
      // this.selected_country = e.COUNTRYID;
      // console.log("select_country==", this.select_country);
      // console.log("selected_country==", this.selected_country);
    },
    onloadDistrictById: async function (select_province, thai_student) {
      api
        .getDistrictByid(select_province, thai_student)
        .then(res => {
          this.districtItems = res.data.data;
        })
        .catch(err => {
          console.log("onloadDistrictById", err.toString());
        });
    },
    onloadSubDistrictById: async function (select_district, thai_student) {
      if (this.select_district != null) {
        api
          .getSubDistrictByid(select_district, thai_student)
          .then(res => {
            this.subdistrictItems = res.data.data;
            // this.select_subdistrict=select_sub;
            // console.log("res==",res);
            // console.log("onloadSubDistrictById=",res.data.data);
          })
          .catch(err => {
            console.log("onloadSubDistrictById", err.toString());
          });
      }
    },
    onloadZipcodeById: async function () {
      api
        .getZipcode(this.select_subdistrict, this.thai_student)
        .then(res => {
          this.current_subdistrict = this.select_subdistrict;
          this.current_zipcode = res.data.data[0].ZIPCODE;
          this.select_subdistrict_name = res.data.data[0].SUB_DISTRICTNAME;
          this.current_subdistrict = res.data.data[0].SUB_DISTRICTNAME;
          // console.log("current_subdistrict==", this.current_subdistrict);
        })
        .catch(err => {
          console.log("onloadZipcodeById", err.toString());
        });
    }
  },
  mounted() {
  }
  ,
  created() {
    for (var j = 11; j <= 23; j++) { //อีเมล์สุดท้าย ==12 ข้อ
      var b = {ID: j, UPDATEDATA: 0, VALUES: 0}
      this.items2.push(b);
    }
    if (this.$store.state.token == null || this.$store.state.user == null) {
      this.$router.push("/Logout");
    } else {
      // this.$router.push("/Dashboard");
    }
    this.std_id = this.$store.state.user.studentid;
    this.thai_student = this.$store.state.user.thaistudent;
    api.onSetHeader();
    this.actionUpdate = this.getCurrentStudent(this.std_id);
    this.getCountry(this.thai_student);
    // this.select_country = 41;
    this.getStudentQuestion();

    // console.log("",this.start )
    if (this.$store.state.user.thaistudent == 1) {
      this.lbl_contry = "ประเทศ";
      this.lbl_address = "ที่อยู่ที่ทำงานต่างประเทศ";
    } else {
      this.lbl_contry = "Country";
      this.lbl_address = "Work address";
    }

  }
}
;
</script>
<style>
</style>
